(ns minorodata.connections.sources.asana
  "Connector screen for asana"
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "asana"
   :enabled      false
   :name         "Asana (Deprecated)"
   :description  "Keep remote and distributed teams, and your entire organization, focused on their goals, projects, and tasks"
   :image-source "asana.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description access-token]} data]
        {:source-type "asana"
         :name        name
         :description description

         :source
         {:credentials         {:type                   "token"
                                :access-token           access-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge
         (select-keys credentials [:access-token])
         {:name              name
          :description       description})))

    :validate (constantly nil)

    :id :asana-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Access Token"
              :required   true
              :name       :access-token
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :asana-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Portfolios"             :value "portfolios"}
                           {:name "Portfolio Memberships"  :value "portfolio-memberships"}
                           {:name "Projects"               :value "projects"}
                           {:name "Project Memberships"    :value "project-memberships"}
                           {:name "Project Statuses"       :value "project-statuses"}
                           {:name "Sections"               :value "sections"}
                           {:name "Stories"                :value "stories"}
                           {:name "Tags"                   :value "tags"}
                           {:name "Tasks"                  :value "tasks"}
                           {:name "Team Memberships"       :value "team-memberships"}
                           {:name "Users"                  :value "users"}
                           {:name "User Task Lists"        :value "user-task-lists"}]
              :required   true
              :value      "portfolios"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
